import React from 'react'
import ListLink from '../../components/listLink/listLink'
import { ExclamationCircle } from '../../svg/exclamation_circle'

const dataLink = [
  {
      title: 'www.prima.com.pe',
      link: 'https://www.prima.com.pe',
  },
  {
      title: 'miespacio.prima.com.pe',
      link: 'https://miespacio.prima.com.pe',
  },
  {
      title: 'www.mundoprima.pe',
      link: 'https://www.mundoprima.pe',
  }
]  

const dataLinkTwo = [
  {
      title: 'Facebook',
      link: 'https://www.facebook.com/PrimaAFP/',
  },
  {
      title: 'Instagram',
      link: 'https://www.instagram.com/primaafp/',
  },
  {
      title: 'LinkedIn',
      link: 'https://pe.linkedin.com/company/prima-afp',
  },
  {
      title: 'Twitter',
      link: 'https://twitter.com/primaafpoficial',
  },
  {
      title: 'YouTube',
      link: 'https://www.youtube.com/channel/UCU6o1n74cGuZqL555IDlkwg',
  },
  {
      title: 'TikTok',
      link: 'https://www.tiktok.com/@primaafp',
  }
]  

const CampanaComunicacion = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Campaña de Comunicación
        </h2>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          En nuestras campañas de comunicación masiva, nunca incluiremos enlaces a otros dominios que no 
          pertenezcan a Prima AFP (1) o a nuestros portales oficiales en las redes sociales (2), y no 
          solicitaremos información de tus cuentas bancarias. Cualquier campaña que llegue a nombre 
          nuestro y no presente alguna de las características mencionadas, debe ser eliminada inmediatamente.
        </p>
        <div
          className={`brad-4 bg-turquoise-1 tw-px-4 tw-pt-3 tw-pb-2 font-family-primary tw-f-16 tw-f-16@lg tw-mt-6 tw-mb-8 tw-mb-10@lg`}
        >
          <div className={`flex`}>
            <div className={`tw-mr-2`}>
              <ExclamationCircle fill={'#04A6A2'} />
            </div>
            <div>
              <p>
                <strong>Recuerda</strong> <br></br>
                Nuestras campañas serán personalizadas, siempre dirigidas a tu nombre.
              </p>
            </div>
          </div>
        </div>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-4@lg'>
          Dominios Prima AFP
        </h3>
        <div className='tw-mb-8 tw-mb-10@lg'>
          {dataLink.map(({ title, link }) => (
              <ListLink title={title} link={link} key={title} />
          ))}
        </div>
        <h3 className='font-family-secondary c-gray--4 tw-m-0 fw-6 tw-f-18 tw-f-18@lg tw-mb-4 tw-mb-4@lg'>
          Redes Sociales Oficiales
        </h3>
        <div className='tw-mb-4 tw-mb-4@lg'>
          {dataLinkTwo.map(({ title, link }) => (
              <ListLink title={title} link={link} key={title} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default CampanaComunicacion
